'use client';

import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import styled from 'styled-components';
import styledCss from '../../Utils/styledCss.js';

var TRANSITION_TIMING = 200;
var MultiLevelCoreContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    transition: height ", "ms ease-in-out;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    ", "\n"], ["\n    transition: height ", "ms ease-in-out;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    ", "\n"])), TRANSITION_TIMING, styledCss.scrollbar);
var ListWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    display: flex;\n    transition: transform ", "ms ease-in-out;\n"], ["\n    ", ";\n    display: flex;\n    transition: transform ", "ms ease-in-out;\n"])), function (_a) {
    var maxHeight = _a.maxHeight;
    return (maxHeight ? "max-height: ".concat(maxHeight, "px") : '');
}, TRANSITION_TIMING);
var List = styled.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: ", "px;\n    flex-shrink: 0;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    ", "\n"], ["\n    width: ", "px;\n    flex-shrink: 0;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    ", "\n"])), function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var isActive = _a.isActive;
    return isActive
        ? ''
        : "\n        height: 0;\n        overflow: hidden;\n    ";
});
var Item = styled.li(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var ItemWrapper = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: block;\n"], ["\n    display: block;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

export { Item, ItemWrapper, List, ListWrapper, MultiLevelCoreContainer };
//# sourceMappingURL=styles.js.map
